import $http from "../../helpers/api";
import objectToFormData from "object-to-formdata";

// initial state
const state = {
    all: [],
    part: [],
    categories: []
};

// getters
const getters = {
    get: state => state.part,
    getAll: state => state.all,
    getCategories: state => state.categories
};

const actions = {
    getAll({
        commit
    }) {
        return new Promise((resolve, reject) => {
            $http.get("/parts").then(resp => {
                commit("setAll", resp.data);
            });
            resolve();
        });
    },
    get({
        commit
    }, part_id) {
        return new Promise((resolve, reject) => {
            $http.get("/parts/" + part_id + "?includes[]=categories").then(resp => {
                commit("set", resp.data.part);
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    add({}, data) {
        let form_data = objectToFormData(data);
        // return console.log(form_data);
        return new Promise((resolve, reject) => {
            $http.post("/parts", form_data, {
                headers: {
                    "content-type": "multipart/form-data"
                }
            }).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    edit({
        commit
    }, data) {
        let form_data = objectToFormData(data);
        return new Promise((resolve, reject) => {
            $http.post("/parts/" + data.part.id, form_data, {
                headers: {
                    "content-type": "multipart/form-data"
                }
            }).then(resp => {
                commit("clearAll");
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    delete({}, data) {
        return new Promise((resolve, reject) => {
            $http.delete("/parts/" + data).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getCategories({
        commit
    }) {
        return new Promise((resolve, reject) => {
            $http.get("/parts/categories").then(resp => {
                commit("setCategories", resp.data);
            });
            resolve();
        });
    }
};
const mutations = {
    setAll(state, data) {
        state.all = data;
    },
    clearAll(state) {
        state.all = [];
        state.parts = [];
        state.categories = [];
    },
    setCategories(state, data) {
        state.categories = data;
    },
    set(state, part) {
        state.part = part;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
